"use client";
import type { TabContentBlockDoc as TabContentBlockProps } from "../../types/blocks";
import React from "react";

export const TabContentBlock: React.FC<TabContentBlockProps> = (props) => {
  return null;
};
